/* eslint-disable no-bitwise */
import { WeekdayNumbers } from 'luxon';
import { WeekDayFlags } from '../../models/models.swagger.generated';

export interface IWeekdays {
  allowedMonday?: boolean;
  allowedTuesday?: boolean;
  allowedWednesday?: boolean;
  allowedThursday?: boolean;
  allowedFriday?: boolean;
  allowedSaturday?: boolean;
  allowedSunday?: boolean;
}

export class WeekDayFlagsHelper {

  public static WEEK_DAY_FLAG_WORKING_DAYS = WeekDayFlags.Monday | WeekDayFlags.Tuesday | WeekDayFlags.Wednesday | WeekDayFlags.Thursday | WeekDayFlags.Friday;
  public static WEEK_DAY_FLAG_WEEKEND = WeekDayFlags.Saturday | WeekDayFlags.Sunday;
  public static WEEK_DAY_FLAG_ALL_DAYS = WeekDayFlagsHelper.WEEK_DAY_FLAG_WORKING_DAYS | WeekDayFlagsHelper.WEEK_DAY_FLAG_WEEKEND;
  public static WEEK_DAY_FLAG_NONE = 0 as WeekDayFlags;

  public static daysToFlag(weekdays: IWeekdays): WeekDayFlags {
    let weekdaysFlag = WeekDayFlagsHelper.WEEK_DAY_FLAG_NONE;
    if (weekdays?.allowedMonday) {
      weekdaysFlag += WeekDayFlags.Monday;
    }
    if (weekdays?.allowedTuesday) {
      weekdaysFlag += WeekDayFlags.Tuesday;
    }
    if (weekdays?.allowedWednesday) {
      weekdaysFlag += WeekDayFlags.Wednesday;
    }
    if (weekdays?.allowedThursday) {
      weekdaysFlag += WeekDayFlags.Thursday;
    }
    if (weekdays?.allowedFriday) {
      weekdaysFlag += WeekDayFlags.Friday;
    }
    if (weekdays?.allowedSaturday) {
      weekdaysFlag += WeekDayFlags.Saturday;
    }
    if (weekdays?.allowedSunday) {
      weekdaysFlag += WeekDayFlags.Sunday;
    }
    return weekdaysFlag;
  }

  public static luxonWeekdayToFlag(weekday: number): WeekDayFlags {
    return 1 << (weekday - 1);
  }

  public static hasFlags(source: WeekDayFlags, daysToCheckFor: WeekDayFlags) {
    return !!(source & daysToCheckFor);
  }

  public static shiftFlagsOneDayBack(dayFlag: WeekDayFlags): WeekDayFlags
  {
      // monday becomes sunday, ...
      const overflowAdd = WeekDayFlagsHelper.hasFlags(dayFlag, WeekDayFlags.Monday) ? WeekDayFlags.Sunday : 0;
      const val = dayFlag >> 1 + overflowAdd;
      return val;
  }

  public static shiftFlagsOneDayForward(dayFlag: WeekDayFlags): WeekDayFlags
  {
      // sunday becomes monday, ...
      const overflowAdd = WeekDayFlagsHelper.hasFlags(dayFlag, WeekDayFlags.Sunday) ? WeekDayFlags.Monday : 0;
      const val = (dayFlag << 1) & WeekDayFlagsHelper.WEEK_DAY_FLAG_ALL_DAYS | overflowAdd;
      return val;
  }
}
